// Service-worker bootstrap. The virtual module is provided by
// vite-plugin-pwa; the dynamic import keeps the registration code out of
// environments where the plugin isn't loaded (tests, SSR, etc.).
//
// onNeedRefresh: a new SW finished installing in the background and is
// waiting to activate. We surface a Sonner toast asking the operator to
// reload — calling updateSW(true) sends SKIP_WAITING + reloads. With
// registerType: 'prompt' (vite.config.ts) the SW won't auto-activate, so
// the operator can finish whatever they're in the middle of.

import { toast } from 'sonner'

export function registerPwa(): void {
  if (typeof window === 'undefined') return
  if (!('serviceWorker' in navigator)) return

  void import('virtual:pwa-register').then(({ registerSW }) => {
    const updateSW = registerSW({
      immediate: true,
      onNeedRefresh() {
        toast('Nova versão disponível', {
          description: 'Recarregar pra ver as últimas mudanças.',
          action: {
            label: 'Recarregar',
            onClick: () => {
              void updateSW(true)
            },
          },
          duration: Infinity,
        })
      },
    })
  })
}
